<template>
    <v-btn
        v-bind="$attrs"
        v-on="$listeners"
        :data-testid="testid"
        color="button"
        class="mt-4"
        block
        x-large
    >
        <v-icon left>{{ this.icon }}</v-icon>
        <span>{{  this.label }}</span>
    </v-btn>
</template>

<script>
export default {
    props: {
			testid: {
				type: String,
				required: true
			},
			icon: {
				type: String,
				default: '',
			},
            label: {
				type: String,
				default: '',
			},
		},
}
</script>
